import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { updateImage } from '../utils/updateImage';
import { toBase64 } from '../utils/toBase64';

/* Material UI */
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

// Icon
import { FaArrowLeft, FaEdit } from 'react-icons/fa'


//alerta
import Notification from '../../components/Notification/Notification';
import ConfirmDialog from '../../components/Notification/ConfirmDialog';
import UserPermission from '../../components/UserPermission';
import { Grid, MenuItem, Typography } from '@mui/material';

const classes = {
    textField: {
        width: '100%',
        backgroundColor: '#fff',
    },
    buttonSubmit: {
        marginTop: 20,
    },
    formControl: {
        marginLeft: 5,
        marginTop: 16,
        width: '50%'
    },
    textTitle: {
        margin: 8,
        color: '#000',
        fontWeight: 600,
        marginBottom: 20
    },
    btnSubmit: {
        backgroundColor: '#1551B3',
        color: '#fff',
        borderRadius: 20,
        height: '45px',
        textTransform: 'none',
        fontWeight: 'bold',
        fontSize: 15,
        marginTop: 0,
        minWidth: '220px'
    },
    btnCancel: {
        backgroundColor: '#F5F5F5',
        color: '#174FB3',
        borderRadius: 20,
        height: '45px',
        textTransform: 'none',
        fontWeight: 'bold',
        fontSize: 15,
        marginTop: 0,
        minWidth: '220px'
    },
    message: {
        padding: 10,
        backgroundColor: '#FFFBE8',
        color: 'rgba(0,0,0,0.8)',
        borderRadius: 7,
        width: '100%'
    },
    inputFile: {
        border: 'dashed 2px #BABABA',
        height: 55.972,
        borderRadius: 5,
        textAlign: 'center',
        backgroundColor: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    inputFileLabel: {
        fontSize: 12,
        position: 'absolute',
        transform: 'translate(8px, -9px)',
        color: "#656565",
        background: "white",
        width: 220,
        textAlign: 'center'
    }
};



export default function CategoryEdit() {
    const history = useNavigate();

    // Permissão do usuário no sistema
    let userPermission = UserPermission();

    useEffect(() => {
        if (userPermission !== 'admin') {
            toast.error("Seu usuário não possuí privilégios para acessar essa página!");
            history("/search");
        }
    }, [userPermission, history]);

    const { id } = useParams();

    const [name, setName] = useState('');
    const [target, setTarget] = useState('');
    const [grupo, setGrupo] = useState('');
    const [timeOfAttendance, setTimeOfAttendance] = useState('');
    const [description, setDescription] = useState('');
    const [notify, setNotify] = useState({ isOpen: false, message: '', type: '', title: '' });
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' });
    const [allGroups, setAllGroups] = useState([]);

    const [isChangedIcon, setIsChangedIcon] = useState(false)
    const [inputIcon, setInputIcon] = useState(null)
    const [icon, setIcon] = useState();
    const iconFileInput = isChangedIcon ||
        icon == null ||
        icon === '' ? { width: '70%' } : { width: '128px' }

    useEffect(() => {
        api.get(`admin/areas/${id}`)
            .then((response) => {
                const data = response.data;

                setName(data.name);
                setTimeOfAttendance(data.timeOfAttendance);
                setGrupo(data.groupId);
                setDescription(data.description);
                setIcon(data.picture?.body)
                setTarget(data.target)
            })

        api.get('groups')
            .then((response) => {
                setAllGroups(response.data);
            })
    }, [id]);
    //Id como dependencia para renderização

    const cleanFields = () => {
        setName('');
        setTimeOfAttendance('');
        setGrupo('');
        setDescription('');
    }

    //chama o alerta para cadastrar
    function confirms(dados) {
        dados.preventDefault();

        const data = {
            name,
            description,
            groupId: grupo,
            target: target,
            timeOfAttendance: parseInt(timeOfAttendance)
        };

        setConfirmDialog({
            isOpen: true,
            title: `Você está editando o tipo?`,
            subTitle: `Você confirma a alteração com os novos dados?`,
            onConfirm: () => { handleEditArea(data) }
        })
    }

    /* Função para cadastrar uma categoria */
    async function handleEditArea(data) {
        /* Verifica se o usuário escreveu alguma coisa no input da categoria */
        if (!data.name) {
            setNotify({
                isOpen: true,
                message: 'Preencha o campo Tipo para edita o Tipo.',
                type: 'warning'
            });
            setConfirmDialog({
                ...confirmDialog,
                isOpen: false,
            });

            /* Verifica se a área informada já existe */
        } else {
            try {
                const base64 = await toBase64(icon);
                data.picture = {
                    type: icon.type,
                    body: base64,
                    url: ""
                }
            } catch (err) { }

            try {
                await api.put(`admin/areas/${id}`, data);
                cleanFields(); // deixa o nome vazio

                // fecha janela após cadastrar
                setConfirmDialog({
                    ...confirmDialog,
                    isOpen: false,
                });

                // janela de notificação de sucesso
                setNotify({
                    isOpen: true,
                    message: 'Tipo editado com sucesso.',
                    type: 'success',
                    title: 'Cadastrada'
                });

                setTimeout(() => {
                    history("/categoryregister")
                }, 1000);

            } catch (err) {
                setNotify({
                    isOpen: true,
                    message: 'Ocorreu um erro ao editar o tipo.',
                    type: 'error',
                    title: 'Erro',
                });

                setConfirmDialog({
                    ...confirmDialog,
                    isOpen: false,
                })
            }
        }
    };

    const handleCancel = () => {
        history('/categoryregister')
    }


    if (userPermission !== 'admin') {
        return null;
    } else {
        return (
            <div className="cadastro-container">

                <Typography variant="h5" align="center" style={classes.textTitle}>
                    Edição de tipos de Ocorrências
                </Typography>


                <div style={classes.message}>
                    Preencha o formulário abaixo para editar a ocorrência selecionada.
                </div>

                <form onSubmit={confirms} style={{ marginTop: 20 }}>
                    <Grid container spacing={2} alignItems="center" justifyContent="center">
                        <Grid item xs={8} md={8}>
                            <TextField
                                style={{ background: '#fff' }}
                                required
                                fullWidth
                                label="Nome do Tipo"
                                value={name}
                                onChange={e => setName(e.target.value)}
                            />
                        </Grid>

                        <Grid style={{ position: 'relative' }} item xs={12} sm={12} md={4} lg={4}>
                            <div style={classes.inputFileLabel}>Selecione uma imagem para este tipo</div>
                            <div style={classes.inputFile}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: '10px' }}>
                                    <input
                                        style={iconFileInput}
                                        accept="image/*"
                                        label='Icone'
                                        type='file'
                                        onChange={(e) => {
                                            updateImage(e.target.files[0], setInputIcon);
                                            setIcon(e.target.files[0]);
                                            setIsChangedIcon(true)
                                        }
                                        }
                                    />
                                    <div style={{ height: '100%' }}>
                                        <img src={isChangedIcon ? inputIcon : icon} width={30} height={30} alt="Ícone da categoria" />
                                    </div>
                                </div>
                            </div>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                style={{ background: '#fff' }}
                                required
                                type='number'
                                fullWidth
                                label="Tempo de previsão de atendimento (em dias)"
                                value={timeOfAttendance}
                                onChange={e => setTimeOfAttendance(e.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl variant="outlined" required fullWidth>
                                <InputLabel id="Grupo">Grupo</InputLabel>
                                <Select
                                    label="Grupo"
                                    labelId="Grupo"
                                    style={{ background: '#fff' }}
                                    value={grupo}
                                    onChange={e => setGrupo(e.target.value)}
                                >
                                    {
                                        allGroups.map((group) => (
                                            <MenuItem key={group.id} value={group.id}>{group.nameSecretary}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl variant="outlined" required fullWidth>
                                <InputLabel>Serviço de Destino</InputLabel>
                                <Select
                                    style={{ background: '#fff' }}
                                    value={target}
                                    onChange={e => setTarget(e.target.value)}
                                    label="Serviço de Destino"
                                    labelId="Serviço de Destino"
                                >
                                    <MenuItem value={'Cidadão'}>Cidadão</MenuItem>
                                    <MenuItem value={'Visão'}>Visão</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12}>
                            <TextField
                                label="Descrição"
                                required
                                fullWidth
                                style={{ backgroundColor: '#fff' }}
                                multiline
                                rows={4}
                                value={description}
                                onChange={e => setDescription(e.target.value)}
                            />
                        </Grid>

                        <Grid item>
                            <Button
                                variant='outlined'
                                style={classes.btnCancel}
                                onClick={handleCancel}
                                startIcon={<FaArrowLeft style={{ 'color': '#174FB3' }} />}
                            >
                                Voltar
                            </Button>
                        </Grid>

                        <Grid item>
                            <Button
                                variant='outlined'
                                style={classes.btnSubmit}
                                type='submit'
                                startIcon={<FaEdit style={{ 'color': 'white' }} />}
                            >
                                Salvar
                            </Button>
                        </Grid>
                    </Grid>
                </form>

                <Notification
                    notify={notify}
                    setNotify={setNotify}
                />
                <ConfirmDialog
                    confirmDialog={confirmDialog}
                    setConfirmDialog={setConfirmDialog}
                />
            </div>
        );
    }
}